import { render, staticRenderFns } from "./RemarkPage.vue?vue&type=template&id=5f7a643a&scoped=true"
import script from "./RemarkPage.vue?vue&type=script&lang=js"
export * from "./RemarkPage.vue?vue&type=script&lang=js"
import style0 from "./RemarkPage.vue?vue&type=style&index=0&id=5f7a643a&prod&lang=scss&scoped=true"
import style1 from "./RemarkPage.vue?vue&type=style&index=1&id=5f7a643a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a643a",
  null
  
)

export default component.exports